/**
 * Equivalent to reduce array into an object
 * @example
 *
 * [{a:'holo'}, {b:'world'}].reduce((acc, next) => ({...acc, ...next}), {}) // {a:'holo', b:'world'}
 * collapse([{a:'holo'}, {b:'world'}]) // {a:'holo', b:'world'}
 *
 * @param parts
 * @returns
 */
export function collapse<T>(parts: T[]): T {
  return Object.assign({}, ...parts);
}
